import _createForOfIteratorHelper from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import { canUseDOM } from '../../utils';
export var runValidations = function runValidations(validationFunctions) {
  for (var _len = arguments.length, validateParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    validateParams[_key - 1] = arguments[_key];
  }
  var _iterator = _createForOfIteratorHelper(validationFunctions),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var validate = _step.value;
      if (!validate.apply(void 0, validateParams)) return false;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return true;
};
export var validateRequired = function validateRequired(value, fieldObj) {
  value = value.trim();
  if (value.length) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorRequired);
    return false;
  }
};
export var validateRequiredSelect = function validateRequiredSelect(value, fieldObj) {
  if (value === '-1' || value === -1) {
    fieldObj.setError(fieldObj.errorRequired);
    return false;
  } else {
    fieldObj.setError('');
    return true;
  }
};
export var validateMaxLength = function validateMaxLength(value, fieldObj) {
  if (value.length <= fieldObj.maxLength) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorMaxLength);
    return false;
  }
};
export var validateMinLength = function validateMinLength(value, fieldObj) {
  if (value.length >= fieldObj.minLength) {
    fieldObj.setError('');
    return true;
  } else {
    fieldObj.setError(fieldObj.errorMinLength);
    return false;
  }
};
export var validateRegex = function validateRegex(regEx) {
  return function (value, fieldObj) {
    if (regEx.test(value)) {
      fieldObj.setError('');
      return true;
    } else {
      fieldObj.setError(fieldObj.errorValue);
      return false;
    }
  };
};
export var validateRegexInverse = function validateRegexInverse(regEx) {
  return function (value, fieldObj) {
    if (!regEx.test(value)) {
      fieldObj.setError('');
      return true;
    } else {
      fieldObj.setError(fieldObj.errorValue);
      return false;
    }
  };
};

// /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
// export const validateAlphanumeric = validateRegex(/^[\u0621-\u064A\u0660-\u06690-9a-zA-Z]+$/);

var alphaNumericRegex = /\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|\s/g;
export var validateEmail = validateRegex(/^.+\@.+\..+$/);
export var validateAlphanumeric = validateRegexInverse(alphaNumericRegex);
export var validatePassword = validateRegex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}/);
export var handleErrors = function handleErrors(response) {
  if (!response.ok) {
    var status = response.status;
    if (status === 401) {
      throw Error("Unauthorized access");
    } else {
      throw Error(response.statusText);
    }
  }
  return response;
};
export var validateRequiredCheckbox = function validateRequiredCheckbox(value, fieldObj) {
  var errorsList = [];
  var _iterator2 = _createForOfIteratorHelper(fieldObj.checkboxes),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var checkbox = _step2.value;
      if (checkbox.isRequired && checkbox.isRequired === true && checkbox.value === false) {
        errorsList.push(checkbox.errorRequired);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (errorsList.length) {
    fieldObj.setError(errorsList.join('[|]'));
    return false;
  } else {
    fieldObj.setError('');
    return true;
  }
};
export var loaderToggle = function loaderToggle(toggle, btnStateDisable) {
  if (canUseDOM) {
    if (toggle) {
      btnStateDisable(true);
      document.body.classList.add('loader--show');
    } else {
      btnStateDisable(false);
      document.body.classList.remove('loader--show');
    }
  }
};